import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const FilterSectionTemplate = htmlE`<div
  class="filter-sorting-section is-flex is-align-items-center is-flex-wrap-wrap is-justify-content-space-between"
>
  <div
    class="filter-input-container bg-primaryMain is-flex is-align-items-center is-flex-wrap-wrap"
  >
    <div
      class="is-flex is-align-items-center filter-input-wrapper bg-primaryMain is-relative"
    >
      <label
        for="${"prefixId"}-filter-input"
        class="text-sm text-primaryMain"
        data-i18n-key="filter"
        >${"filterText"}
      </label>
      <input
        id="${"prefixId"}-filter-input"
        class="input filter-input bg-primaryMain"
        type="text"
        autocomplete="off"
      />
      <div id="${"prefixId"}-filterResultNotification" class="filter-result-notification is-flex gap-2 text-sm">
      </div>

      ${({ prefixId }) => {
        if (prefixId === "dashboard") {
          return `<div id="searchResultNotification" class="px-2 is-flex is-align-items-center gap-2 text-sm">
      </div>`;
        }
      }}
    </div>
  </div>
  <div
    class="is-flex is-align-items-center is-flex-wrap-wrap is-hidden"
    id="readonly-banner">
    <span data-i18n-key="readOnlyFolderWarning">This folder is read-only</span>
  </div>
  <div class="is-flex is-align-items-center is-flex-wrap-wrap gap-3">
  ${({
    prefixId,
    expandAllText,
    collapseAllText,
    arrangeColumnsText,
    enableColumnArrangement,
    showExpandCollapseAllForTreeView,
  }) => {
    if (prefixId === "dashboard") {
      return `
      <div class="listing-expand-collapse-menu is-flex gap-3">
      ${
        enableColumnArrangement
          ? `<button
        tabindex="0"
        type="button"
        id="arrangeFileListingTableColumns"
        class="primary-button is-bg-none p-0 navbar-item-label"
        aria-label="arrange-listing-table-columns-btn"
      >
        <i class="icon-list text-accentMain mr-2"></i>
        <span data-i18n-key="arrangeColumns">${arrangeColumnsText}</span>
      </button>`
          : ""
      }
      ${
        showExpandCollapseAllForTreeView
          ? `<button
        tabindex="0"
        type="button"
        id="expandAllFolderListing"
        class="primary-button is-bg-none p-0 navbar-item-label"
        aria-label="expand-all-btn"
      >
        <i class="icon-folder-open text-accentMain mr-2"></i>
        <span data-i18n-key="expandAll">${expandAllText}</span>
      </button>`
          : ""
      }
      ${
        showExpandCollapseAllForTreeView
          ? `<button
        tabindex="0"
        type="button"
        id="collapseAllFolderListing"
        class="primary-button is-bg-none p-0 navbar-item-label"
        aria-label="collapse-all-btn"
      >
        <i class="icon-folder-close text-accentMain mr-2"></i>
        <span data-i18n-key="collapseAll">${collapseAllText}</span>
      </button>`
          : ""
      }
    </div>
      `;
    }
  }}

    <div class="dropdown" id="${"prefixId"}-filter-select-dropdown">
      <button
        tabindex="0"
        type="button"
        class="primary-button is-bg-none p-0 navbar-item-label dropdown-trigger"
        aria-label="select-btn"
      >
        <span data-i18n-key="select">${"selectText"}</span>
        <i class="icon-chevron-down ml-2"></i>
      </button>
      <div class="dropdown-menu">
        <div class="dropdown-content">
          <button
            id="${"prefixId"}-toggle"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="toggle">
              ${"toggle"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkAll"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="allItems">
              ${"allItems"}
            </span>
          </button>
          <button
            id="${"prefixId"}-uncheckAll"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="none">
              ${"none"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkAllFiles"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="allFiles">
              ${"allFiles"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkAllFolders"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="allFolders">
              ${"allFolders"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkItemsWithDot"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="itemStartingWithDOT">
              ${"itemStartingWithDOT"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkToday"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="modifiedToday">
              ${"modifiedToday"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkWeek"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="modifiedThisWeek">
              ${"modifiedThisWeek"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkMonth"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="modifiedThisMonth">
              ${"modifiedThisMonth"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkLastTwoMonth"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="modifiedInLast60Days">
              ${"modifiedInLast60Days"}
            </span>
          </button>
          <button
            id="${"prefixId"}-checkLastThreeMonth"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="modifiedInLast90Days">
              ${"modifiedInLast90Days"}
            </span>
          </button>
        </div>
      </div>
    </div>
    <!-- For Sorting -->
    <div class="dropdown" id="${"prefixId"}-grid-sorting-dropdown">
      <button
        tabindex="0"
        type="button"
        class="primary-button is-bg-none p-0 navbar-item-label dropdown-trigger"
        aria-label="sort-btn"
      >
        <span data-i18n-key="sort">${"sortText"}</span>
        <i class="icon-chevron-down ml-2"></i>
      </button>
      <div style="width: 13rem" class="dropdown-menu">
        <div class="dropdown-content">
          <button
            id="${"prefixId"}-name-sort-grid"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="name">
              ${"nameText"}
            </span>
          </button>
          <button
            id="${"prefixId"}-size-sort-grid"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="size">
              ${"sizeText"}
            </span>
          </button>
          <button
            id="${"prefixId"}-modified-sort-grid"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="lastModified">
              ${"lastModifiedText"}
            </span>
          </button>
          <button
            id="${"prefixId"}-keywords-sort-grid"
            class="dropdown-item is-justify-content-space-between"
          >
            <span data-i18n-key="keywords">
              ${"keywordsText"}
            </span>
          </button>
        </div>
      </div>
    </div>
    <!-- End -->
    ${({ hideKeepDirectoryOnTop, prefixId, keepDirectoriesOnTopText }) => {
      if (!hideKeepDirectoryOnTop) {
        return `
      <div class="is-flex is-align-items-center">
        <input
        class="is-cursor-pointer"
        id="${prefixId}-directory-sorting"
        type="checkbox"
      />
      <label
        for="${prefixId}-directory-sorting"
        class="text-sm text-primaryMain ml-1 is-cursor-pointer"
        data-i18n-key="keepDirectoriesOnTopWhileSorting"
        >${keepDirectoriesOnTopText}</label
      >
    </div>
      `;
      }
    }}
    <div
      id="${"prefixId"}-file-view-dropdown"
      ${({ dropdownParent }) => {
        return `${dropdownParent ? ` parentElement=${dropdownParent}` : ""}`;
      }}
      class="dropdown file-view-dropdown"
    >
      <button
        tabindex="0"
        type="button"
        class="primary-button is-bg-none is-align-items-center dropdown-trigger"
        aria-label="list-view-btn"
      >
        <span
          class="text-primaryMain text-lg mr-1"
          id="${"prefixId"}-grid-icon-wrapper"
        >
          <i class="icon-th-list"></i>
        </span>
        <i class="icon-chevron-down text-primaryMain ml-1"></i>
      </button>
      <div class="dropdown-menu">
        <div class="dropdown-content">
          <button
            id="${"prefixId"}-handle-grid-btn"
            class="dropdown-item is-align-items-center"
            aria-label="grid-btn"
          >
            <i class="icon-th text-accentMain text-lg"></i>
            <span class="ml-4" data-i18n-key="smallGrid">
              ${"smallGridText"}
            </span>
          </button>
          <button
            id="${"prefixId"}-handle-medium-grid-btn"
            class="dropdown-item is-align-items-center"
            aria-label="medium-grid-btn"
          >
            <i class="icon-table text-accentMain text-lg"></i>
            <span class="ml-4" data-i18n-key="mediumGrid">
              ${"mediumGridText"}
            </span>
          </button>
          <button
            id="${"prefixId"}-handle-large-grid-btn"
            class="dropdown-item is-align-items-center"
            aria-label="large-grid-btn"
          >
            <i class="icon-th-large text-accentMain text-lg"></i>
            <span class="ml-4" data-i18n-key="largeGrid">
              ${"largeGridText"}
            </span>
          </button>
          <button
            id="${"prefixId"}-handle-grid-list-btn"
            class="dropdown-item is-align-items-center"
            aria-label="list-btn"
          >
            <i class="icon-th-list text-accentMain text-lg"></i>
            <span class="ml-4" data-i18n-key="list">
              ${"listText"}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>`;

const searchFilterResultTemplate = htmlE`
<button
  data-i18n-key="clear"
  id="${"prefixId"}-clear-filter"
  class="primary-button is-bg-none p-0"
>
${"clearText"}
</button>
<p>(<span data-i18n-key="filterApplied">${"filterApplied"}</span>)</p>
<p
  id="${"prefixId"}-filterResultAnimation"
    class="filter-result-data w-full"
    data-i18n-key="filterApplied"
  >${"filterApplied"}</p>
`;

const searchResultClearTemplate = htmlE`
<span class="icon is-small">
  <i class="icon-search"></i>
</span>
<p><span data-i18n-key="showingSearchResult">${"showingSearchResultText"}</span></p>
<span>:</span>
<button
  data-i18n-key="clear"
  id="search-result-clear-button"
  class="primary-button is-bg-none p-0"
>
${"clearText"}
</button>
`;

export {
  FilterSectionTemplate as default,
  searchFilterResultTemplate,
  searchResultClearTemplate,
};
